import { Injectable, inject } from '@angular/core';

import { TotalsPrefix } from '@cds/betting-offer';
import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { replace } from 'lodash-es';

import { OptionNameStrategy } from './option-name.strategy';

@Injectable({ providedIn: 'root' })
export class PlayerMilestoneMarketAttributeOptionNameStrategy extends OptionNameStrategy {
    private sitecore = inject(Sitecore);

    override getOptionName(option: EventOption): string {
        return option.optionAttribute === TotalsPrefix.Over || option.optionAttribute === TotalsPrefix.Under
            ? `${this.prefix(option.optionAttribute)} ${replace(option.marketAttribute!, ',', '.')}`
            : option.name;
    }

    private prefix(optionAttribute: TotalsPrefix): string {
        return optionAttribute === TotalsPrefix.Over ? this.sitecore.eventGrid.SixPack_TotalsOver : this.sitecore.eventGrid.SixPack_TotalsUnder;
    }
}
